export class Pos {
  public id : string;
  public net_ref: string;
  public net_ref__icontains: string;
  public storename__icontains: string;
  public city: string;
  public network_id: string;
  public last_modified: string;
  public status: string;
  public zipcode__icontains: string;
  public city__icontains: string;
}
